import { getCurrentEpisodes } from '@audacy-clients/core/atoms/episodes';
import { getSchedules } from '@audacy-clients/core/atoms/schedules';
import {
  type IEpisode,
  type TWrappedContentObject,
} from '@audacy-clients/core/atoms/wrappers/types';
import { isValidEpisodeOrFiller } from '@audacy-clients/core/utils/episode';
import { contentQuery } from './content';
import { noCacheDefaultSelectorFamily } from './helpers/noCacheDefaultSelector';

type ILiveNowParams = {
  contentId?: string;
  isStation?: boolean;
};

export const liveEpisodeFromSchedule = noCacheDefaultSelectorFamily<
  IEpisode | undefined,
  ILiveNowParams
>({
  key: 'LiveEpisodeFromSchedule',
  get:
    ({ contentId, isStation }) =>
      ({ get }) => {
        if (!contentId) {
          return undefined;
        }

        const episodes = get(
          isStation
            ? getSchedules(contentId)
            : getCurrentEpisodes(contentId)
        )
        if (!episodes) {
          return undefined;
        }

        const now = Date.now()
        const list = episodes.getAll()

        if (list.length <= 1) {
          return undefined;
        }

        const liveNowEpisode = list.find(
          e =>
            now > e.startTime &&
            now < e.endTime &&
            isValidEpisodeOrFiller(e) &&
            !e.isOnAirOnly
        )
        return liveNowEpisode
      },
})

type ICurrentShowParams = {
  contentId?: string;
  isStation: boolean;
};

export const getCurrentShow = noCacheDefaultSelectorFamily<
  { currentShow: TWrappedContentObject | undefined; url: string | undefined } | undefined,
  ICurrentShowParams
>({
  get:
    ({ contentId, isStation }) =>
    ({ get }) => {
      if (!contentId) {
        return undefined;
      }

      const liveScheduleItem = get(liveEpisodeFromSchedule({ contentId, isStation }));
      const show = get(contentQuery(liveScheduleItem?.showContentId));

      return { currentShow: show, url: liveScheduleItem?.url };
    },
  key: 'CurrentShow',
});
